<div class="session bg-primary">
  <div class="session-content" >
    <div class="flex-box" class="flex-box-monkey">
      <img src="assets/images/monkey-1.png" alt="Monkey" title="Monkey" class="monkey-1"/>
      <img src="assets/images/monkey-2.png" alt="Monkey" title="Monkey" class="monkey-2"/>
      <mat-card class="mat-card-flat flex-card width-card">
        <mat-card-content>
            <div fxLayout="column">
              <div class="text-xs-center pb-1">
                <img src="assets/images/logo.png" alt="Smart contact" title="Smart contact" width="150" />
                <div class="full-width mt-1">
                  <button type="button" mat-stroked-button (click)="backLogin()" tabindex="1">
                    <span class="font-weight-bold">{{ username }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  </button>
                </div>
                <h2 class="mt-1 mb-0">{{ 'login.your_domain' | translate }}</h2>
              </div>
              <div *ngIf="domainNames.length > 10">
                <flex-search-input [formControl]="filterControl"></flex-search-input>
              </div>
              <div class="enterprise-list-block" perfectScrollbar>
                <mat-list [disableRipple]="true">
                  <ng-container *ngFor="let dm of filteredDomainNames; let i = index; last as isLast">
                    <a mat-button (click)="selectDomainName(dm)" class="full-width pa-1">
                      <div class="mat-text-primary font-weight-bold text-lg">{{ domainEnterprises[dm] }}</div>
                    </a>
                    <mat-divider [inset]="true" *ngIf="!isLast"></mat-divider>
                  </ng-container>
                </mat-list>
              </div>
            </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
